export default __webpack_public_path__ + "static/media/settings-green.e3bbf1fe.svg";